import type { socialEn } from './social-en.ts';

type DeepString<T> = T extends string ? string : { [K in keyof T]: DeepString<T[K]> };

/** Italian strings of the people of a player. Typed against the English shape. */
export const socialIt: DeepString<typeof socialEn> = {
  social: {
    title: 'Amici',
    intro:
      'Chiedi a un amico il suo soprannome e le quattro cifre che lo seguono, e manda la richiesta.',
    gate: {
      unavailable: 'Gli amici non sono disponibili in questa versione',
      unavailableBody: 'Questa build non ha un servizio account, che gli amici richiedono.',
      signIn: 'Accedi per avere degli amici',
      signInBody: 'Amici, inviti e blocchi vanno con un account.',
      signInAction: 'Vai all’account',
      guest: 'Un ospite non ha amici',
      guestBody: 'Trasforma questo ospite in un account per chiedere l’amicizia agli altri.',
      off: 'Per ora gli amici sono spenti.',
      loading: 'Cerco i tuoi amici…',
      failed: 'Non sono riuscito a caricare i tuoi amici. Riprova.',
      retry: 'Riprova',
    },
    add: {
      title: 'Chiedi a qualcuno di essere tuo amico',
      label: 'Soprannome e cifre',
      hint: 'Come Ada#0042.',
      action: 'Manda la richiesta',
      outcome: {
        requested: 'Richiesta mandata a {{name}}.',
        accepted: 'Tu e {{name}} ora siete amici.',
        already: 'Siete già amici, oppure la richiesta aspetta una risposta.',
        notFound: 'Non c’è nessuno con quel nome. Controlla il soprannome e le quattro cifre.',
        blocked: 'Hai bloccato questo giocatore. Sbloccalo prima.',
        self: 'Quello sei tu.',
        accountRequired: 'Gli ospiti non possono avere amici.',
        full: 'La tua lista è piena, o hai troppe richieste in attesa.',
      },
      failed: 'Non sono riuscito a mandare la richiesta. Riprova.',
    },
    requests: {
      title: 'Richieste',
      incoming: '{{name}} chiede di essere tuo amico.',
      outgoing: 'Aspetto la risposta di {{name}}.',
      accept: 'Accetta',
      decline: 'Rifiuta',
      cancel: 'Ritira',
    },
    friends: {
      title: 'Amici',
      empty: 'Ancora nessun amico.',
      remove: 'Rimuovi',
      block: 'Blocca',
      join: 'Unisciti',
      heists: 'I loro colpi',
      heistsClose: 'Nascondi i loro colpi',
      heistsEmpty:
        'Nessun colpo da rivedere. I replay si conservano 30 giorni e il colpo del giorno non si mostra mai.',
      heistsFailed: 'Non si sono potuti caricare i colpi.',
      heistDone: 'Colpo riuscito',
      heistFailed: 'Colpo fallito',
      heistRole: 'come {{role}}',
      watch: 'Guarda',
      presence: {
        online: 'Qui',
        offline: 'Assente',
        lobby: 'A un tavolo',
        playing: 'In gioco',
      },
    },
    blocked: {
      title: 'Giocatori bloccati',
      empty: 'Non hai bloccato nessuno.',
      note: 'Non lo sanno. Non vedi quello che scrivono.',
      unblock: 'Sblocca',
    },
    notices: {
      title: 'Dai moderatori',
      ban: 'Il tuo account è sospeso dal gioco online.',
      mute: 'La tua chat è silenziata. Le frasi rapide funzionano ancora.',
      warn: 'Hai ricevuto un richiamo.',
      until: 'Fino al {{date}}.',
      forever: 'Finché un moderatore non lo toglie.',
      reason: 'Motivo: {{reason}}',
    },
    notifications: {
      title: 'Ultime',
      friend_request: '{{name}} ha chiesto di essere tuo amico.',
      friend_accepted: '{{name}} ha accettato la tua richiesta.',
      moderation: 'Un moderatore è intervenuto sul tuo account.',
    },
    invite: {
      banner: '{{name}} ti invita a un colpo.',
      join: 'Unisciti',
      dismiss: 'Non ora',
    },
    room: {
      title: 'Invita gli amici',
      empty: 'Per ora nessuno dei tuoi amici è qui.',
      action: 'Invita',
      sent: 'Invito mandato a {{name}}.',
      error: {
        rateLimited: 'Aspetta un momento prima di invitare di nuovo {{name}}.',
        offline: '{{name}} se n’è appena andato.',
        notInRoom: 'Gli inviti sono per una stanza privata che non è ancora partita.',
        notFriends: 'Non sei amico di {{name}}.',
        featureOff: 'Per ora gli inviti sono spenti.',
        unreachable: 'Non sono riuscito a mandare l’invito. Riprova.',
        generic: 'Non sono riuscito a mandare l’invito.',
      },
    },
    actions: {
      title: 'Giocatore',
      open: 'Azioni per {{name}}',
      addFriend: 'Chiedi l’amicizia',
      block: 'Blocca',
      report: 'Segnala',
      close: 'Chiudi',
      blocked: '{{name}} è bloccato. Non vedrai quello che scrive.',
      failed: 'Non ha funzionato. Riprova.',
    },
    report: {
      title: 'Segnala {{name}}',
      reason: 'Qual è il problema?',
      reasons: {
        chat: 'Chat offensiva',
        name: 'Nome offensivo',
        cheating: 'Imbroglia',
        abandon: 'Lascia i colpi apposta',
        other: 'Altro',
      },
      detail: 'Raccontaci di più (facoltativo)',
      send: 'Manda la segnalazione',
      sent: 'Segnalazione mandata. Grazie: la guarderà un moderatore.',
      already: 'Hai già segnalato questo giocatore per questo motivo.',
      limit: 'Oggi hai mandato molte segnalazioni. Riprova domani.',
      notFound: 'Non c’è nessuno con quel nome.',
      self: 'Quello sei tu.',
      invalid: 'La segnalazione non è valida.',
      failed: 'Non sono riuscito a mandare la segnalazione. Riprova.',
    },
  },
};
